import { Directive, ElementRef, Renderer2, AfterViewInit } from '@angular/core';

@Directive({
    selector: '[sedsViewFix]',
    standalone: false
})
export class SedsViewFixDirective implements AfterViewInit {
  constructor(private readonly element: ElementRef, private readonly render: Renderer2) {}

  ngAfterViewInit() {
    let biggestWidth = 0;
    for (const child of this.element.nativeElement.children) {
      const rect = child.getBoundingClientRect();
      if (rect.width > biggestWidth) {
        biggestWidth = rect.width;
      }
    }

    for (const child of this.element.nativeElement.children) {
      this.render.setStyle(child, 'width', `${biggestWidth}px`);
    }

    const rect = this.element.nativeElement.getBoundingClientRect();
    const multiplier =
      this.element.nativeElement.children.length / 4 + (this.element.nativeElement.children.length % 4 > 0 ? 1 : 0);

    const ulPadding = 10;
    const elementWidth = biggestWidth * Math.trunc(multiplier) + ulPadding + 12;

    const screenWidth = window.screen.width;
    const elementMargin = 80;
    const diff =
      rect.left + elementWidth + elementMargin > screenWidth
        ? rect.left + elementWidth + elementMargin - screenWidth
        : 0;

    this.render.setStyle(this.element.nativeElement, 'width', `${elementWidth}px`);

    if (diff > 0) {
      this.render.setStyle(this.element.nativeElement, 'margin-left', `-${diff}px`);
    }
  }
}
